import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\DuplicatePackController::__invoke
* @see app/Http/Controllers/Pack/DuplicatePackController.php
* @route '/api/pack-duplicate/{pack}'
*/
const DuplicatePackController = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: DuplicatePackController.url(args, options),
    method: 'put',
})

DuplicatePackController.definition = {
    methods: ["put"],
    url: '/api/pack-duplicate/{pack}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Pack\DuplicatePackController::__invoke
* @see app/Http/Controllers/Pack/DuplicatePackController.php
* @route '/api/pack-duplicate/{pack}'
*/
DuplicatePackController.url = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { pack: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { pack: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            pack: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        pack: typeof args.pack === 'object'
        ? args.pack.id
        : args.pack,
    }

    return DuplicatePackController.definition.url
            .replace('{pack}', parsedArgs.pack.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\DuplicatePackController::__invoke
* @see app/Http/Controllers/Pack/DuplicatePackController.php
* @route '/api/pack-duplicate/{pack}'
*/
DuplicatePackController.put = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: DuplicatePackController.url(args, options),
    method: 'put',
})

export default DuplicatePackController